// extracted by mini-css-extract-plugin
module.exports = {"dialogLine":"DialogLine_dialogLine_2A86a","isStyleDingBeauty":"DialogLine_isStyleDingBeauty_2_GR2"};